<div class="component-wrapper">
    <div class="mail-icon-wrapper">
        <i class="mail-icon" alt="Mail logo"></i>
    </div>
    <div class="confirmtext">
        <h2 class="title"> {{ titleMessage }}</h2>    
        <p class="message">{{ message }}</p>
    </div>
</div>